import { createFileRoute } from "@tanstack/react-router"
import { RoleDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/organization-settings/roles-permissions/$roleUuid/$tabKey"
)({
  component: () => (
    <AuthorizationGate resource={Resource.ROLE} action={Action.READ}>
      <RoleDetailPage />
    </AuthorizationGate>
  ),
})
